/**
 * HTTP response helpers — shared util cho mọi service file.
 *
 * BE wrap response trong `Http.responseObject({ ... })` shape:
 *   `{ success: boolean, data: <payload>, message?: string, ... }`
 *
 * Pattern này được Nhân establish ở EG-356 (commit e6ffc84, 2026-04-29).
 * Mọi service mới (order, product, inventory, ...) PHẢI import `unwrap` từ đây
 * thay vì khai báo lại local — tránh duplicate logic.
 */

/** Bóc layer wrapper `Http.responseObject({ data: ..., success: true })`. */
export function unwrap<T = Record<string, unknown>>(raw: unknown): T {
  if (raw && typeof raw === 'object' && 'data' in raw) {
    const inner = (raw as { data: unknown }).data;
    if (inner && typeof inner === 'object') return inner as T;
  }
  return (raw ?? {}) as T;
}
